function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import FormLabelGroup from "../Form/FormLabelGroup";
import Input from "../Input/Input";
import Col from "../Layout/Col";
import Row from "../Layout/Row";
import CountryInput from "./CountryInput";
import getAddressFormat from "./util/AddressFormats";
var defaultProps = {
  disabled: false,
  error: {},
  hints: {},
  labels: {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  showLabels: false,
  value: {
    countryCode: 'US'
  }
};

var InternationalAddressInput = function InternationalAddressInput(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? defaultProps.disabled : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? defaultProps.error : _ref$error,
      _ref$hints = _ref.hints,
      hints = _ref$hints === void 0 ? defaultProps.hints : _ref$hints,
      id = _ref.id,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? defaultProps.labels : _ref$labels,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? defaultProps.onBlur : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      _ref$showLabels = _ref.showLabels,
      showLabels = _ref$showLabels === void 0 ? defaultProps.showLabels : _ref$showLabels,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? defaultProps.value : _ref$value;

  var countryCode = value.countryCode;
  var addressFormat = getAddressFormat(countryCode);
  var fields = getAddressFormat(countryCode).fields;

  var i18nLabels = _objectSpread(_objectSpread({}, addressFormat.labels), labels);

  var states = addressFormat.states;
  var inputId = id || 'addressInput';
  var stateId = "".concat(inputId, "_state");
  var countryCodeId = "".concat(inputId, "_countryCode");

  var onAddressChange = function onAddressChange(field) {
    onChange(_objectSpread(_objectSpread({}, value), field)); // TODO state not resetting
  };

  var inputFor = function inputFor(type) {
    return /*#__PURE__*/React.createElement(Input, {
      disabled: disabled,
      id: "".concat(inputId, "_").concat(type),
      invalid: !!error[type],
      name: type,
      onBlur: function onBlur() {
        return _onBlur(type);
      },
      onChange: function onChange(e) {
        return onAddressChange(_defineProperty2({}, type, e.target.value));
      },
      placeholder: i18nLabels[type],
      type: "text",
      value: value[type] || ''
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, fields.map(function (row) {
    return /*#__PURE__*/React.createElement(Row, {
      className: "gx-0"
    }, row.map(function (field, index) {
      var label = i18nLabels[field];
      return /*#__PURE__*/React.createElement(Col, {
        sm: true
      }, /*#__PURE__*/React.createElement(FormLabelGroup, {
        feedback: error[field],
        hint: hints[field],
        inputId: "".concat(inputId, "_").concat(field),
        label: label,
        srLabel: !showLabels,
        rowClassName: index > 0 ? 'ps-sm-2' : undefined,
        stacked: true
      }, field === 'address1' && inputFor('address1'), field === 'address2' && inputFor('address2'), field === 'city' && inputFor('city'), field === 'postal' && inputFor('postal'), field === 'countryCode' && /*#__PURE__*/React.createElement(CountryInput, {
        className: "w-100",
        disabled: disabled,
        id: countryCodeId,
        invalid: !!error.countryCode,
        name: "countryCode",
        onBlur: function onBlur() {
          return _onBlur('countryCode');
        },
        onChange: function onChange(country) {
          return onAddressChange({
            countryCode: country !== null ? country : undefined,
            state: undefined
          });
        },
        placeholder: i18nLabels.countryCode,
        value: value.countryCode
      }), field === 'state' && /*#__PURE__*/React.createElement(Input, {
        className: "custom-select",
        disabled: disabled,
        id: stateId,
        invalid: !!error.state,
        name: "state",
        onBlur: function onBlur() {
          return _onBlur('state');
        },
        onChange: function onChange(e) {
          return onAddressChange({
            state: e.target.value
          });
        },
        placeholder: i18nLabels.state,
        type: "select",
        value: value.state
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, i18nLabels.state), !!states && states.map(function (_ref2) {
        var name = _ref2.name,
            code = _ref2.code;
        return /*#__PURE__*/React.createElement("option", {
          key: code,
          value: code
        }, name);
      }))));
    }));
  }));
};

InternationalAddressInput.displayName = "InternationalAddressInput";
InternationalAddressInput.defaultProps = defaultProps;
InternationalAddressInput.displayName = 'InternationalAddressInput';
export default InternationalAddressInput;